import SnackbarComponent from './Snackbar.component';

export * from './Snackbar.component';
export default SnackbarComponent;
